/** Glued-cluster feedback: neighbours joined away from home read as one movable block. */
export const PIECE_GLUE_FLASH_MS = 620;
export const PIECE_GLUE_CLEANUP_MS = 800;

/** Persistent outline for a piece glued to at least one neighbour (piece silhouette, not a box). */
export const PIECE_GLUE_GLOW_FILTER =
    "drop-shadow(0 0 1.5px rgba(255, 176, 32, 0.95)) drop-shadow(0 0 6px rgba(255, 214, 92, 0.6))";

const STYLE_ID = "jigsaw-piece-glue-keyframes";

/** Inject once: one-shot amber burst played when pieces snap together. */
export function ensurePieceGlueStyle() {
    if (typeof document === "undefined") return;
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
@keyframes jigsaw-piece-glue-flash {
  0% { filter: drop-shadow(0 0 0 rgba(255, 214, 92, 0)) brightness(1); }
  30% {
    filter: drop-shadow(0 0 12px rgba(255, 214, 92, 0.95)) brightness(1.18);
  }
  100% { filter: drop-shadow(0 0 0 rgba(255, 214, 92, 0)) brightness(1); }
}
.jigsaw-piece-glue-flash {
  animation: jigsaw-piece-glue-flash ${PIECE_GLUE_FLASH_MS}ms ease-out both;
}
`;
    document.head.appendChild(style);
}
